function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEu = function SvgEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300mm",
    height: "300mm",
    viewBox: "0 0 300 300"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 107.224 121.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -10.394 3.533)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 48.36 19.418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 91.447 62.342)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 91.393 179.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 48.415 222.992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -69.203 222.774)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -112.18 179.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -128.012 121.15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -112.18 62.233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -69.203 19.255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m600.397 165.33-39.466-27.435-39.439 27.472 13.896-46.012-38.314-29.019 48.053-1.002 15.76-45.407 15.802 45.392 48.055.956-38.288 29.056z",
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.13392639,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28592 0 0 .28465 -7.402 238.442)"
  }));
};
export default SvgEu;